import { AlertInline, Box } from '@frameio/vapor';
import TEXT from './generated/TEXT/BillingStripeFormError';

TEXT.DEFINE({
  /** Generic error message when payment or billing update fails */
  tryAgain: 'Something went wrong, please try again.',
  /** Error message when user lacks permission to update billing */
  permissionDenied: 'You do not have permission to make this change.',
});

type StripeFormErrorProps = {
  apolloErrorMessage?: string;
  messageForDisplay?: string;
};

export function StripeFormError({
  apolloErrorMessage,
  messageForDisplay,
}: StripeFormErrorProps) {
  const apolloErrorMessageMap: Record<string, string> = {
    'permission denied': TEXT.permissionDenied,
  };

  const apolloErrorForDisplay = apolloErrorMessage
    ? apolloErrorMessageMap[apolloErrorMessage]
    : undefined;

  return (
    <Box paddingTop={16}>
      <AlertInline variant="error">
        {messageForDisplay || apolloErrorForDisplay || TEXT.tryAgain}
      </AlertInline>
    </Box>
  );
}
